/* eslint-disable linebreak-style */

export enum QUESTION_DELIVERY_TYPE {
    NO_RANDOMIZATION = 'none',
    RANDOMIZE_ORDER = 'shuffle',
    PULL_FROM_SECTION = 'selection',
    CANDIDATE_SELECTION = 'manual-selection',
}
export interface Resource {
    id: number;
    questionNumbering: string;
    sectionIndex: number;
    revisionId: number;
    liveRevisionId: number;
    name: string;
    type: string;
    lastModified: string;
    createdOn: string;
    modifiedBy: string;
    hasPermission: boolean;
    createdInQB: string;
    isMandatoryQuestion?: boolean;
    isManuallyCorrectable: string;
    labels: string;
    thumbnailURL: string;
    maxScore: number;
    weight: number;
    supportedLanguages: string[];
    scoreEachCorrect: number;
    scoreEachWrong: number;
    isNewestRevision: string;
    metadata: {
        assessmentFilterTags: string;
    };
}
export interface Item {
    id: number;
    name: string;
    fixed: boolean;
    category: string;
    sectionIndex: number;
    resource: Resource;
}
export interface Section {
    isAuthorVersion2: boolean;
    name: string;
    id: number;
    sectionQuestionOrdering: string;
    numberOfQuestionsToPull: number;
    layout: string;
    stimulusSize: number;
    allowStimulusResizing: boolean;
    hasPermission: boolean;
    items: Item[];
}
export interface Assessment {
    id: number;
    contentRevisionId: number;
    contentItemId: number;
    name: string;
    lastModified: number;
    isGenericEmptyQuestionSet: boolean;
    isVisible: string;
    sharedWithUsers: number;
    sharedWithOrgUnits: number;
    linkedWithTaxonomyNodes: number;
    // eslint-disable-next-line camelcase
    assessment_status: string;
    supportedLanguages: string[];
    isAuthorVersion2: boolean;
    hasOnlyOralQuestions: boolean;
    hasOnlyMultipleChoiceQuestion: boolean;
    hasManuallyCorrectable: boolean;
    hasAutomaticallyCorrectable: boolean;
    hasRandomizableAlternativesQuestions: boolean;
    hasAtLeastOneUploadQuestion: boolean;
    hasNestedSections: boolean;
    hasOfflineUnsupportedQuestions: boolean;
    hasOneWayNavigation: boolean;
    sections: Section[];
    atLeastOneBandedMarking: boolean;
    questionsUsedInOtherAssessments: Record<string, unknown>;
    additionalResources: any[];
    modifiedBy: string;
    /** From GetAssessment.writeItembankInfo when item-bank content privacy is enabled. */
    securityInherit?: boolean;
    userHasAccessToShareContent?: boolean;
}
